import styled from "styled-components";

import { Image as LibImage } from "@components/DataDisplay/Image";

export const Root = styled.aside`
  position: absolute;
  inset: 0;
  overflow: hidden;
  z-index: -2;
`;

export const Image = styled(LibImage)`
  position: absolute;
  inset: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
`;
